var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFootball(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 7.12866L7.99121 11.1245L10.0261 16.0083H15.7239L17.7588 11.1245L12.875 7.12866Z",
    fill: "#6C6C6C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8752,
    cy: 12.0124,
    r: 11.4875,
    stroke: "#6C6C6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1208 4.02086L9.19921 1.18565L13.1208 0.0125707L16.9052 1.01397L13.1208 4.02086Z",
    fill: "#6C6C6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38527 11.1233L1.13635 13.9656L1.11235 9.87234L3.13668 6.52175L5.38527 11.1233Z",
    fill: "#6C6C6C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55176 10.6807L8.87953 11.1246",
    stroke: "#6C6C6C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 3.5769V8.90468L13.763 12.0125",
    stroke: "#6C6C6C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7552 9.79272L15.9834 11.5686",
    stroke: "#6C6C6C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3153 19.1162L14.6514 14.2324",
    stroke: "#6C6C6C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10352 19.1162L11.5433 14.2324",
    stroke: "#6C6C6C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99151 18.2282L8.45909 22.668L5.43638 20.9598L3.10771 17.6909L7.99151 18.2282Z",
    fill: "#6C6C6C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8717 18.6721L21.7555 19.1161L19.483 21.8237L15.6747 23.091L16.8717 18.6721Z",
    fill: "#6C6C6C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6928 10.3553L22.2406 5.70204L24.3575 8.53295L24.7215 12.53L20.6928 10.3553Z",
    fill: "#6C6C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootball);
export default __webpack_public_path__ + "static/media/football.021aaa39241828c4ad207a8bdac68e1a.svg";
export { ForwardRef as ReactComponent };